import type { ClienteCatalogo } from './cliente-catalogo.service'

const STORAGE_KEY = 'catalogo_tokens'

export type StoredTokenData = {
  clienteCnpj: string
  empresaId: number
  token: string
  dataCriacao: string
  dataExpiracao: string
  ativo: boolean
}

export const saveCatalogoToken = (clienteCnpj: string, tokenData: ClienteCatalogo) => {
  try {
    const stored = getStoredTokens()
    const key = `${tokenData.empresaId}_${clienteCnpj}`
    
    stored[key] = {
      clienteCnpj,
      empresaId: tokenData.empresaId,
      token: tokenData.token || '',
      dataCriacao: tokenData.dataCriacao || '',
      dataExpiracao: tokenData.dataExpiracao || '',
      ativo: tokenData.ativo || false,
    }
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
  } catch (error) {
    console.error('Erro ao salvar token no localStorage:', error)
  }
}

export const getCatalogoToken = (clienteCnpj: string, empresaId: number): StoredTokenData | null => {
  try {
    const stored = getStoredTokens()
    const key = `${empresaId}_${clienteCnpj}`
    return stored[key] || null
  } catch (error) {
    console.error('Erro ao buscar token no localStorage:', error)
    return null
  }
}

export const removeCatalogoToken = (clienteCnpj: string, empresaId: number) => {
  try {
    const stored = getStoredTokens()
    const key = `${empresaId}_${clienteCnpj}`
    delete stored[key]
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
  } catch (error) {
    console.error('Erro ao remover token do localStorage:', error)
  }
}

export const isTokenValid = (tokenData: StoredTokenData, currentUserJwt?: string): boolean => {
  if (!tokenData.ativo) return false
  
  const now = new Date()
  const expiracao = new Date(tokenData.dataExpiracao)
  
  // Verifica se o token expirou por data
  if (expiracao <= now) return false
  
  // Se temos o JWT atual do usuário, compara para ver se mudou (logout/login)
  if (currentUserJwt) {
    const storedJwt = getStoredUserJwt()
    if (storedJwt && storedJwt !== currentUserJwt) {
      // JWT mudou, token é inválido
      return false
    }
    // Salva o JWT atual para próximas comparações
    setStoredUserJwt(currentUserJwt)
  }
  
  return true
}

const JWT_STORAGE_KEY = 'catalogo_user_jwt'

const getStoredUserJwt = (): string | null => {
  try {
    return localStorage.getItem(JWT_STORAGE_KEY)
  } catch (error) {
    console.error('Erro ao acessar JWT no localStorage:', error)
    return null
  }
}

const setStoredUserJwt = (jwt: string) => {
  try {
    localStorage.setItem(JWT_STORAGE_KEY, jwt)
  } catch (error) {
    console.error('Erro ao salvar JWT no localStorage:', error)
  }
}

export const clearUserJwt = () => {
  try {
    localStorage.removeItem(JWT_STORAGE_KEY)
  } catch (error) {
    console.error('Erro ao remover JWT do localStorage:', error)
  }
}

const getStoredTokens = (): Record<string, StoredTokenData> => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : {}
  } catch (error) {
    console.error('Erro ao acessar localStorage:', error)
    return {}
  }
}